<div class="e-ngx-calendar">
	<div *ngIf="isShowYearAndMonth" class="yearAndMonth-view">
		<div class="yearAndMonth">
			<div class="yearAndMonth-close" (click)="toggleYearAndMonth()" title="關閉">
				<i class="fa fa-times-circle" aria-hidden="true"></i>
			</div>
			<div class="select-header">
				<span *ngIf="isShowMonthView" (click)="showYearView(selectYear)">{{selectYear}}</span>
				<span *ngIf="isShowYearView">{{selectYearText}}</span>
				<span *ngIf="isShowYearView" [ngClass]="{disable: maxTenYear}"
					  class="nextTenYear glyphicon glyphicon-chevron-down" (click)="nextTenYear()"></span>
				<span *ngIf="isShowYearView" [ngClass]="{disable: minTenYear}"
					  class="preTenYear glyphicon glyphicon-chevron-up" (click)="preTenYear()"></span>
			</div>
			<div class="select-content">
				<ul *ngIf="isShowMonthView">
					<li *ngFor="let month of monthData; let i = index;" [ngClass]="{select: selectMonth === i}"
						(click)="changeMonth(i)">
						<span>{{month}}</span>
					</li>
				</ul>
				<ul *ngIf="isShowYearView">
					<li *ngFor="let year of yearData; let i = index;"
						[ngClass]="{select: selectYear === year, disable: isInTenYear(year)}"
						(click)="changeYear(year)">
						<span>{{year}}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>

	<div class="calendar-header">
		<span class="today" (click)="backToday()">返回今天</span>
		<div class="dateSelect">
			<span class="preMonth" (click)="preMonth()" style="cursor: pointer;"></span>
			<span class="dateText" (click)="toggleYearAndMonth()" style="cursor: pointer;">{{now | date: "yyyy年MM月"}}</span>
			<span class="nextMonth" (click)="nextMonth()" style="cursor: pointer;"></span>
		</div>
	</div>
	<div class="calendar-content">
		<div class="row">
			<div class="col-md-12">
				<div class="panel panel-default">
					<div class="dateHeader">
						<span *ngFor="let week of weekData;" class="week">
							{{week}}
						</span>
					</div>
					<ul>
						<li *ngFor="let monthData of calendarData.monthData; let i=index"
							[ngClass]="{disable: isNotSameMonth(monthData.year, monthData.month), currDay: isCurrDay(monthData.year, monthData.month, monthData.day)}">


							<div *ngIf="!!initSchedules" class="handle">
								<!-- <a href="javascript:void(0);" title="新增事件" (click)="addSchedule(monthData)">
									<i class="fa fa-plus-circle" aria-hidden="true"></i>
								</a>   
                                &nbsp; 插入空格 -->
								<!-- <a *ngIf="monthData.data?.length > 0" href="javascript:void(0);" title="觀看詳細" (click)="viewAllSchedule(monthData)">
									<i class="fa fa-list" aria-hidden="true"></i>
								</a> -->
							</div>

							<p style="margin-bottom: 4px">{{monthData.day}}</p>

                            <span style="font-size: medium;" [style.color]="spcolor[i]">筆數:{{ monthData.data?.length || 0 }}</span>

							<ul>
								<li *ngFor="let schedule of monthData.data;"   (click)="check_info()">
									<a href="javascript:void(0);" class="text_con" [title]="schedule.title" *ngIf="schedule.lsstatus == '-2'" style="color: rgb(99, 36, 182);"
									   (click)="viewSchedule(monthData, schedule);viewAllSchedule(monthData)">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{schedule.title}}
									</a>
                                    <a href="javascript:void(0);" class="text_con" [title]="schedule.title" *ngIf="schedule.lsstatus == '-1'" style="color: rgb(0, 0, 0);"
									   (click)="viewSchedule(monthData, schedule);viewAllSchedule(monthData)">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{schedule.title}}
									</a>
                                    <a href="javascript:void(0);" class="text_con" [title]="schedule.title" *ngIf="schedule.lsstatus == '0'" style="color: rgb(255, 102, 0);"
									   (click)="viewSchedule(monthData, schedule);viewAllSchedule(monthData)">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{schedule.title}}
									</a>
                                    <a href="javascript:void(0);" class="text_con" [title]="schedule.title" *ngIf="schedule.lsstatus == '1'" style="color: rgb(35, 168, 79);"
									   (click)="viewSchedule(monthData, schedule);viewAllSchedule(monthData)">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{schedule.title}}
									</a>
                                    <a href="javascript:void(0);" class="text_con" [title]="schedule.title" *ngIf="schedule.lsstatus == '2'" style="color: rgb(35, 130, 168);"
									   (click)="viewSchedule(monthData, schedule);viewAllSchedule(monthData)">
										<i class="fa fa-star" aria-hidden="true"></i>
										{{schedule.title}}
									</a>
									<!-- <a href="javascript:void(0);" class="del_con" title="删除"
									   (click)="deleteSchedule(schedule)">
										<i class="fa fa-trash"></i>
									</a> -->
									<a href="javascript:void(0);" class="text_dotted" [title]="schedule.title">
										...
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
